// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/utenti/selezionabili?societaId=N',
    requestBody: null,
    response: '{"success":"true","data":[{"id":"number","nome":"string"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/insegne',
    requestBody: null,
    response: '[{"id":"number","nome":"string","codice":"string"}]'
  },
  {
    method: 'GET',
    endpoint: '/api/nominativi',
    requestBody: null,
    response: '{"data":[{"id":"number","codice":"string","tipoSoggetto":"string","ragioneSociale":"string","isCliente":"boolean","isFornitore":"boolean","disattivato":"boolean","bloccato":"boolean"}],"total":"number","multiSocieta":"boolean"}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
